import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./Screens/Home";
import ReturnRefund from "./Screens/ReturnRefund";
import Cancellation from "./Screens/Cancellation";
import Logo from './images/logo.jpeg'
import Privacy from "./Screens/Privacy";

export default function App() {

  return (
    <Router>
      <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">
          <Link class="navbar-brand" to="/">
            <img alt="Logo" src={Logo} style={{ height: 40, width: 40, borderRadius: 100 }} />
          </Link>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
              <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li class="nav-item">
              <Link className="nav-link" to="/return-refund">
                  Return & Refund Policy
                </Link>
              </li>
              
              <li class="nav-item">
              <Link className="nav-link" to="/shipping">
                  Shipping Policy
                </Link>
              </li>

              <li class="nav-item">
              <Link className="nav-link" to="/privacy">
                  Privacy Policy
                </Link>
              </li>
            </ul>
            <form class="d-flex" role="search">
              <input
                class="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button class="btn btn-outline-success" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/return-refund" element={<ReturnRefund />} />
        <Route exact path="/shipping" element={<Cancellation />} />
        <Route exact path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}
